import clsx from 'clsx';
import { useMemo, useRef } from 'react';
import { Heart } from 'react-feather';

import { ClientReviewResponse } from '@vestico/model';

import { getIsRTL } from '@vestico/i18n';

import style from './LikePreview.module.css';

export interface LikePreviewProps {
  response: ClientReviewResponse;
  isOverlay?: boolean;
}

export const LikePreview = ({ response, isOverlay }: LikePreviewProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const isRTL = useMemo(() => getIsRTL(), []);

  const { likes } = response;

  if (likes <= 0) {
    return null;
  }

  return (
    <div className={clsx(style.root, { [style.overlay]: isOverlay })} ref={ref}>
      <div className={clsx(style.container, { [style.rtl]: isRTL })}>
        <Heart />
        <span>{likes}</span>
      </div>
    </div>
  );
};
